/**
 * Aztrix
 * Smart address book for individuals and organisations, respecting privacy.
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DuplicateRepresentation {
  criterium?: Array<DuplicateRepresentation.CriteriumEnum>;
  contactIds?: Array<string>;
  id?: string;
}
export namespace DuplicateRepresentation {
  export type CriteriumEnum =
    | 'USERNAME'
    | 'FIRST_NAME'
    | 'MIDDLE_NAME'
    | 'LAST_NAME'
    | 'NAME'
    | 'AVATAR'
    | 'GENDER'
    | 'BIRTHDAY'
    | 'FOUNDED'
    | 'DISSOLVED'
    | 'DAY'
    | 'MONTH'
    | 'YEAR'
    | 'EMAIL'
    | 'MOBILE_PHONE'
    | 'PHONE'
    | 'FAX'
    | 'WEBSITE'
    | 'BIC'
    | 'JOB_TITLE'
    | 'INDUSTRY'
    | 'GROUP'
    | 'REGION'
    | 'ADDRESS'
    | 'STREET'
    | 'COUNTRY'
    | 'BUILDING'
    | 'BOX'
    | 'LOCALITY'
    | 'NUMBER'
    | 'ZIP'
    | 'DISTRICT'
    | 'PROVINCE'
    | 'SUBURB'
    | 'STATE'
    | 'COUNTY'
    | 'LAT_LONG'
    | 'FACEBOOK'
    | 'YOUTUBE'
    | 'INSTAGRAM'
    | 'WHATSAPP'
    | 'WECHAT'
    | 'TIKTOK'
    | 'FACEBOOK_MESSENGER'
    | 'TELEGRAM'
    | 'SNAPCHAT'
    | 'PINTEREST'
    | 'TWITTER'
    | 'REDDIT'
    | 'LINKEDIN'
    | 'VIMEO'
    | 'DISCORD'
    | 'TWITCH'
    | 'TUMBLR'
    | 'MASTODON'
    | 'PATREON'
    | 'KICKSTARTER'
    | 'INDIEGOGO'
    | 'GOFUNDME'
    | 'TAKEAWAY'
    | 'UBEREATS'
    | 'DELIVEROO'
    | 'SHIPTO'
    | 'WEIBO'
    | 'QQ'
    | 'KUAISHOU'
    | 'QZONE'
    | 'SKYPE'
    | 'NOTE'
    | 'ORGANISATION_NAME'
    | 'LEGAL_NAME'
    | 'LEGAL_FORM'
    | 'LEGAL_ID'
    | 'COMPANY_NUMBER'
    | 'JURISDICTION'
    | 'IMPORT_SOURCE'
    | 'PROPOSAL'
    | 'CATEGORY'
    | 'OPENING_HOURS'
    | 'CUSTOM'
    | 'FILE'
    | 'IMAGE'
    | 'FILE_KEY'
    | 'FILE_NAME'
    | 'TERMS_AND_CONDITIONS'
    | 'PRIVACY_POLICY'
    | 'DOCUMENT'
    | 'DOCUMENT_NAME'
    | 'ORGANISATION_TYPE';
  export const CriteriumEnum = {
    USERNAME: 'USERNAME' as CriteriumEnum,
    FIRST_NAME: 'FIRST_NAME' as CriteriumEnum,
    MIDDLE_NAME: 'MIDDLE_NAME' as CriteriumEnum,
    LAST_NAME: 'LAST_NAME' as CriteriumEnum,
    NAME: 'NAME' as CriteriumEnum,
    AVATAR: 'AVATAR' as CriteriumEnum,
    GENDER: 'GENDER' as CriteriumEnum,
    BIRTHDAY: 'BIRTHDAY' as CriteriumEnum,
    FOUNDED: 'FOUNDED' as CriteriumEnum,
    DISSOLVED: 'DISSOLVED' as CriteriumEnum,
    DAY: 'DAY' as CriteriumEnum,
    MONTH: 'MONTH' as CriteriumEnum,
    YEAR: 'YEAR' as CriteriumEnum,
    EMAIL: 'EMAIL' as CriteriumEnum,
    MOBILE_PHONE: 'MOBILE_PHONE' as CriteriumEnum,
    PHONE: 'PHONE' as CriteriumEnum,
    FAX: 'FAX' as CriteriumEnum,
    WEBSITE: 'WEBSITE' as CriteriumEnum,
    BIC: 'BIC' as CriteriumEnum,
    JOB_TITLE: 'JOB_TITLE' as CriteriumEnum,
    INDUSTRY: 'INDUSTRY' as CriteriumEnum,
    GROUP: 'GROUP' as CriteriumEnum,
    REGION: 'REGION' as CriteriumEnum,
    ADDRESS: 'ADDRESS' as CriteriumEnum,
    STREET: 'STREET' as CriteriumEnum,
    COUNTRY: 'COUNTRY' as CriteriumEnum,
    BUILDING: 'BUILDING' as CriteriumEnum,
    BOX: 'BOX' as CriteriumEnum,
    LOCALITY: 'LOCALITY' as CriteriumEnum,
    NUMBER: 'NUMBER' as CriteriumEnum,
    ZIP: 'ZIP' as CriteriumEnum,
    DISTRICT: 'DISTRICT' as CriteriumEnum,
    PROVINCE: 'PROVINCE' as CriteriumEnum,
    SUBURB: 'SUBURB' as CriteriumEnum,
    STATE: 'STATE' as CriteriumEnum,
    COUNTY: 'COUNTY' as CriteriumEnum,
    LAT_LONG: 'LAT_LONG' as CriteriumEnum,
    FACEBOOK: 'FACEBOOK' as CriteriumEnum,
    YOUTUBE: 'YOUTUBE' as CriteriumEnum,
    INSTAGRAM: 'INSTAGRAM' as CriteriumEnum,
    WHATSAPP: 'WHATSAPP' as CriteriumEnum,
    WECHAT: 'WECHAT' as CriteriumEnum,
    TIKTOK: 'TIKTOK' as CriteriumEnum,
    FACEBOOK_MESSENGER: 'FACEBOOK_MESSENGER' as CriteriumEnum,
    TELEGRAM: 'TELEGRAM' as CriteriumEnum,
    SNAPCHAT: 'SNAPCHAT' as CriteriumEnum,
    PINTEREST: 'PINTEREST' as CriteriumEnum,
    TWITTER: 'TWITTER' as CriteriumEnum,
    REDDIT: 'REDDIT' as CriteriumEnum,
    LINKEDIN: 'LINKEDIN' as CriteriumEnum,
    VIMEO: 'VIMEO' as CriteriumEnum,
    DISCORD: 'DISCORD' as CriteriumEnum,
    TWITCH: 'TWITCH' as CriteriumEnum,
    TUMBLR: 'TUMBLR' as CriteriumEnum,
    MASTODON: 'MASTODON' as CriteriumEnum,
    PATREON: 'PATREON' as CriteriumEnum,
    KICKSTARTER: 'KICKSTARTER' as CriteriumEnum,
    INDIEGOGO: 'INDIEGOGO' as CriteriumEnum,
    GOFUNDME: 'GOFUNDME' as CriteriumEnum,
    TAKEAWAY: 'TAKEAWAY' as CriteriumEnum,
    UBEREATS: 'UBEREATS' as CriteriumEnum,
    DELIVEROO: 'DELIVEROO' as CriteriumEnum,
    SHIPTO: 'SHIPTO' as CriteriumEnum,
    WEIBO: 'WEIBO' as CriteriumEnum,
    QQ: 'QQ' as CriteriumEnum,
    KUAISHOU: 'KUAISHOU' as CriteriumEnum,
    QZONE: 'QZONE' as CriteriumEnum,
    SKYPE: 'SKYPE' as CriteriumEnum,
    NOTE: 'NOTE' as CriteriumEnum,
    ORGANISATION_NAME: 'ORGANISATION_NAME' as CriteriumEnum,
    LEGAL_NAME: 'LEGAL_NAME' as CriteriumEnum,
    LEGAL_FORM: 'LEGAL_FORM' as CriteriumEnum,
    LEGAL_ID: 'LEGAL_ID' as CriteriumEnum,
    COMPANY_NUMBER: 'COMPANY_NUMBER' as CriteriumEnum,
    JURISDICTION: 'JURISDICTION' as CriteriumEnum,
    IMPORT_SOURCE: 'IMPORT_SOURCE' as CriteriumEnum,
    PROPOSAL: 'PROPOSAL' as CriteriumEnum,
    CATEGORY: 'CATEGORY' as CriteriumEnum,
    OPENING_HOURS: 'OPENING_HOURS' as CriteriumEnum,
    CUSTOM: 'CUSTOM' as CriteriumEnum,
    FILE: 'FILE' as CriteriumEnum,
    IMAGE: 'IMAGE' as CriteriumEnum,
    FILE_KEY: 'FILE_KEY' as CriteriumEnum,
    FILE_NAME: 'FILE_NAME' as CriteriumEnum,
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS' as CriteriumEnum,
    PRIVACY_POLICY: 'PRIVACY_POLICY' as CriteriumEnum,
    DOCUMENT: 'DOCUMENT' as CriteriumEnum,
    DOCUMENT_NAME: 'DOCUMENT_NAME' as CriteriumEnum,
    ORGANISATION_TYPE: 'ORGANISATION_TYPE' as CriteriumEnum,
  };
}
